<template>
    <div>
        <Auth></Auth>
        <v-content :class="{'ma-0': $vuetify.breakpoint.smAndDown,'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-container :class="{'ma-0': $vuetify.breakpoint.smAndDown,'pa-0': $vuetify.breakpoint.smAndDown}">
            <v-layout justify-center >
                <v-form v-model="valid" ref="form" autocomplete="off" lazy-validation>
                    <div  :class="{'ma-0': $vuetify.breakpoint.smAndDown,'pa-0': $vuetify.breakpoint.smAndDown, 'border': $vuetify.breakpoint.smAndUp}" class="text-md-center text-sm-center text-xs-center" >
                        <!--<v-progress-linear v-if="progress" v-bind:indeterminate="progress" value="15" height="3"></v-progress-linear>    -->
                        <v-progress-linear style="margin-top: auto;" v-if="progress" v-bind:indeterminate="progress" value="16" height="5"></v-progress-linear>
                        <v-container> 
                            <Overlay  v-if = "dialog_progress"></Overlay>
                            <!--<v-card-title primary-title class="pt-3 pb-0">-->
                                <div xs12 class="text-md-center text-sm-center text-xs-center">
                                    <img src="/images/logo.png" class="pt-1" style="height:30px;">
                                    <!--<h3 class="subheading mb-2 primary--text">{{ app_name }}</h3>  -->
                                    <h3 class="headline mb-0 text-md-center text-sm-center text-xs-center mt-2">Generate new password</h3>
                                    <div style="color:#000000c2" class="text-md-center text-sm-center text-xs-center">enter your customer id & primary mobile number</div>
                                    
                                </div>
                            <!--</v-card-title> -->
                            
                            <v-card-text>
                                
                                <div class="text-xs-left mb-4"  v-if="error_messages"><span class="text-xs-left" align-left style="color:red;" :class="['label label-danger']">{{ error_message }}</span></div>
                                
                                <v-text-field v-model="customer_id" name="customer_id" label="Customer ID" :rules="customerRules" required  autocomplete="off" required v-on:keyup.enter="Submit"></v-text-field>
                                <span  class="red--text mt-3" v-if="errors.customer_id">{{errors.customer_id[0]}}</span>
                                <v-text-field v-model="phn_number" name="phn_number" label="Phone Number" mask="##########"  :rules="phoneNoRules" required required v-on:keyup.enter="Submit"   autocomplete="off"></v-text-field>
                                <span  class="red--text mt-3" v-if="errors.primary_phone_number">{{errors.primary_phone_number[0]}}</span>
                            </v-card-text>
                            
                            <div class="Row">
                                <div fluid class="Column text-xs-left text-md-left text-sm-left"><a class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent"  @click="LogIn"> Back to login  </a></div>
                                
                                <div class="Column text-xs-right text-md-right text-sm-right"><v-btn class="primary" @click="Submit" :disabled="!valid">Continue</v-btn></div>
                            </div>
                           
                        </v-container>
                    </div>
                    <v-container>  
                        <p class="pa-6 mt-2 text-md-center text-sm-center text-xs-center grey--text">Powered By <a target="_blank" style="color:grey;text-decoration:none;" href="https://www.cybooz.com/" onMouseOver="this.style.color='#c61450'"     onMouseOut="this.style.color='grey'">Cybooz IT Solutions Pvt Ltd</a></p>
                    </v-container>  
                </v-form>
            </v-layout>
        </v-container>
    </v-content>
    </div>
</template>

<script>

import axios from 'axios'



import Vue from 'vue';

import Vuetify from 'vuetify'

import Auth from '@/components/Auth';

import global from '@/components/rbconstants';

import Overlay from '@/components/Overlay.vue'

export default {
    
     components : {
        
        Auth : Auth,
        
        Overlay : Overlay

    },
    
    data: () => ({
        
        app_name : global.app_name,
        
        valid: true,
        
        progress: false,
        
        dialog_progress: false,
        
        errors: [],
        
        customer_id: '',
        
        phn_number: '',
        
        error_message : '',
        
        error_messages: false,
        
        internal_server_error : '',
        
        customerRules : [(v) => !!v || 'Customer id is required is required'],
        
        phoneNoRules: [(v) => !!v || 'Phone Number is required'],
        
       
    }),
    
    created () {
    
        document.title = 'Forgot Password'+' - '+global.app_name
    },
    
    methods: {
        
        
        Submit :function () {
            
            var app = this
            
            if(this.$refs.form.validate()) {
                
               app.progress = true 
               
               app.valid = false
               
               app.dialog_progress = true
               
               var link = global.links.forgot_password
                
               axios.post(link, {
                
                    customer_id: app.customer_id,
                    
                    primary_phone_number: app.phn_number,
                    
                
                }) 
                
                .then(function (response) {
                    
                    app.progress = false
                    
                    app.valid = true
                    
                    app.dialog_progress = false
                    
                    if(response.status == 200) {
                        
                        var customer_id = response.data.data.user.id
                        
                        app.$router.push({ name: 'ForgotPasswordUpdate', params: { id: customer_id}})
                        
                    }
                    
                    
                }) .catch(function (error) {
                    
                    app.progress = false
                    
                    app.valid = true
                    
                    app.dialog_progress = false
                   
                    if(error)  {
                        
                        if(error.response.data.message == "These credentials do not match our records" || error.response.data.message == "You can request for next OTP only after 5 minutes.") {
                            
                            app.error_message = error.response.data.message
        
                            app.error_messages = true
                            
                            app.errors = []
                            
                            
                        }
                        
                        if(error.response.data.errors) {
                        
                        app.errors = error.response.data.errors
                        
                        }
                        
                    }   
                
                });
                
            }
            
        },
        
        LogIn: function() {
            
            var app = this
            
            window.localStorage.clear();
            
            this.$router.push("/")
            
        }
        
    }
    
  };

 

</script>


<style scoped>
    
    .border {
        
        width: 390px;
        border-radius: 10px;
        border: 1px solid #DADCE0;
        /*border: 2px solid #73AD21;*/
        /*padding: 20px; */
        /*width: 200px;*/
        /*height: 150px;  */
        
    }
    .Row
    {
        display: table;
        width: 100%; /*Optional*/
        table-layout: fixed; /*Optional*/
        border-spacing: 10px; /*Optional*/
    }
    .Column
    {
        display: table-cell;
        /*background-color: red; */
    }
    
</style>